var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c("transition", { attrs: { name: "fade-left" } }, [
        _c("div", { staticClass: "content-left" }, [_c("entra-list")], 1),
      ]),
      _c("transition", { attrs: { name: "fade-right" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.cardRight,
                expression: "cardRight",
              },
            ],
            staticClass: "content-right",
          },
          [
            _c("div", { staticClass: "message" }, [
              _c("div", { staticClass: "info" }, [
                _c("div", { staticClass: "head" }, [
                  _c("img", {
                    staticClass: "avatar",
                    attrs: {
                      src: require("images/avatar_default.png"),
                      width: "70",
                      height: "70",
                    },
                  }),
                  _c("span", { staticClass: "name" }, [
                    _vm._v("欢迎你，" + _vm._s(_vm.userInfo.nickName)),
                  ]),
                ]),
                _c("div", { staticClass: "ms-item" }, [
                  _c("span", [_vm._v("学校：")]),
                  _c("span", { attrs: { title: _vm.userInfo.schoolName } }, [
                    _vm._v(_vm._s(_vm.userInfo.schoolName)),
                  ]),
                ]),
                _c("div", { staticClass: "ms-item" }, [
                  _c("span", [_vm._v("角色：")]),
                  _c("span", { attrs: { title: _vm.roleNameStr } }, [
                    _vm._v(_vm._s(_vm.roleNameStr)),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "btns" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("/v2/exam/create")
                          },
                        },
                      },
                      [_vm._v("新建考试")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "warning" },
                        on: {
                          click: function ($event) {
                            return _vm.$router.push("/v2/marking/index")
                          },
                        },
                      },
                      [_vm._v("快捷批改")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _c("div", { staticClass: "video-help" }, [
              _c("div", { staticClass: "head" }, [
                _c("span", [_vm._v("帮助中心")]),
                _c("span", { on: { click: _vm.toTutorial } }, [_vm._v("更多")]),
              ]),
              _c(
                "div",
                {
                  staticClass: "video",
                  on: {
                    click: function ($event) {
                      return _vm.changeVideo(2)
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("images/video-play.png"),
                      width: "76px",
                      height: "76px",
                    },
                  }),
                  _c("span", [_vm._v("如何创建一场测验")]),
                ]
              ),
              _c("span", { staticClass: "toast" }, [
                _vm._v("操作教学视频(建议观看)"),
              ]),
            ]),
          ]
        ),
      ]),
      _c(
        "yue-dialog",
        {
          staticClass: "video-dialog",
          attrs: { title: "如何创建一场测验", visible: _vm.videoDialogVisible },
          on: {
            "update:visible": function ($event) {
              _vm.videoDialogVisible = $event
            },
            close: _vm.stopVideo,
          },
        },
        [
          _c("video", {
            attrs: {
              id: "video",
              src: _vm.videoSrc,
              controls: "true",
              preload: "meta",
              width: "100%",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }